import { render, staticRenderFns } from "./diff.vue?vue&type=template&id=4d9a5084&scoped=true&"
import script from "./diff.vue?vue&type=script&lang=js&"
export * from "./diff.vue?vue&type=script&lang=js&"
import style0 from "./diff.vue?vue&type=style&index=0&id=4d9a5084&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a5084",
  null
  
)

export default component.exports